/**
 * Canonical billing frequency values accepted by the backend API.
 * Convention: the frontend always posts one of these three strings.
 * UI labels ("Annually", "annual", etc.) are display-only and must be
 * normalised before sending to the API.
 */
export type CanonicalFrequency = 'Monthly' | 'Quarterly' | 'Yearly'

/**
 * Normalise any UI frequency string to the canonical API value.
 * - 'monthly' | 'Monthly' → 'Monthly'
 * - 'quarterly' | 'Quarterly' → 'Quarterly'
 * - 'annual' | 'Annual' | 'Annually' | 'yearly' | 'Yearly' → 'Yearly'
 */
export function toCanonicalFrequency(frequency: string): CanonicalFrequency {
  switch (frequency.toLowerCase()) {
    case 'monthly':
      return 'Monthly'
    case 'quarterly':
      return 'Quarterly'
    case 'annual':
    case 'annually':
    case 'yearly':
      return 'Yearly'
    default:
      return 'Monthly'
  }
}
